import type {
  AverageStat,
  BaseballAverageStatType,
  BasketballAverageStatType,
} from '@sorare/core/src/__generated__/globalTypes';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import type { StatsMode } from '@sorare/core/src/lib/playerSearchView';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

import { BaseballStats } from './BaseballStats/index.tsx';
import { FootballStats } from './FootballStats/index.tsx';
import { NBAStats } from './NBAStats/index.tsx';

export const Stats = () => {
  const { sport } = useSportContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();
  const stats = statsManager[PlayerSearchViewAttributes.STATS];
  const statsMode = statsManager[PlayerSearchViewAttributes.STATS_MODE];

  const onChange = (
    s: AverageStat[] | BasketballAverageStatType[] | BaseballAverageStatType[]
  ) => {
    updatePlayerSearchViewAttribute(PlayerSearchViewAttributes.STATS, s);
  };

  const onStatsModeChange = (s: StatsMode) => {
    updatePlayerSearchViewAttribute(PlayerSearchViewAttributes.STATS_MODE, s);
  };

  switch (sport) {
    case Sport.BASEBALL:
      return (
        <BaseballStats
          stats={stats as BaseballAverageStatType[]}
          statsMode={statsMode}
          onChange={s => onChange(s)}
          onStatsModeChange={s => onStatsModeChange(s)}
        />
      );
    case Sport.NBA:
      return (
        <NBAStats
          stats={stats as BasketballAverageStatType[]}
          onChange={s => onChange(s)}
        />
      );
    case Sport.FOOTBALL:
      return (
        <FootballStats
          stats={stats as AverageStat[]}
          onChange={s => onChange(s)}
        />
      );
    default:
      return null;
  }
};
